const settings = {
  btnSave: 'Speichern',
  off: 'Aus',
  btnRestoreDefault: 'Standardeinstellungen wiederherstellen',

  btnAdvance: {
    show: 'Erweitert anzeigen',
    hide: 'Erweitert ausblenden',
  },

  general: {
    title: 'Allgemein',
    pageTitle: 'Allgemeine Einstellungen',
    groups: {
      general: {
        title: 'Allgemein',
        parameters: {
          timezone: {
            label: 'Zeitzone',
            description: 'Das System',
          },
          defaultLanguage: {
            label: 'Standardsprache',
            description:
              'Bevorzugte Sprache – wird beim Wechsel der Seitenansicht, beim Aktualisieren oder beim Anmelden angewendet, sofern keine Benutzereinstellung festgelegt ist.',
          },
          systemType: {
            label: 'Systemtyp',
            description:
              'Wechsel zwischen imperialen und metrischen Einheiten zur Anpassung der Distanzanzeige im System',
            options: {
              imperial: 'Imperial',
              metric: 'Metrisch',
            },
          },
          addressType: {
            label: 'Adresstyp',
            description:
              'Bestimmt, wie Adressen ausgefüllt werden. „Google“ aktiviert die automatische Vervollständigung über Google, „Ort“ verwendet gespeicherte Orte aus dem Systemmodul „Orte“ und „Beide“ bietet beide Optionen.',
            options: {
              both: 'Beide',
              google: 'Google',
              location: 'Ort',
            },
          },
        },
      },
      auth: {
        title: 'Authentifizierung',
        parameters: {
          twoFA: {
            label: 'Zwei-Faktor-Authentifizierung (2FA) erzwingen',
            description:
              'Wenn aktiviert, müssen sich alle Benutzer auf neuen Geräten mit Zwei-Faktor-Authentifizierung anmelden.',
          },
        },
      },
      booking: {
        title: 'Buchung',
        parameters: {
          preventDuplications: {
            label: 'Warnung bei doppelten Reservierungen',
            description:
              'Aktivieren, um beim Ausfüllen einer Buchung mit identischen Details eine Warnmeldung anzuzeigen, oder deaktivieren, um diese Warnung auszuschalten.',
          },
          isWaitAndReturnEnabled: {
            label: 'Warten & Rückfahrt aktivieren',
            description: '',
          },
        },
      },
      map: {
        title: 'Karte',
        parameters: {
          mapServer: {
            label: 'Kartenserver',
            description: 'OSRM-Kartenserver',
          },
          mapCenter: {
            label: 'Kartenzentrum',
            description: 'Legt den Standard-Mittelpunkt der Kartenansicht fest',
          },
          mapZoom: {
            label: 'Kartenzoom',
            description: 'Der Standard-Zoom für Karten in der Plattform',
          },
        },
      },
    },
  },

  routing: {
    title: 'Routenplanung',
    pageTitle: 'Routen-Einstellungen',
    groups: {
      base: {
        title: 'Basis',
        parameters: {
          sharedRideRatio: {
            label: 'Max. gemeinsame Zeitquote',
            description:
              'Maximal erlaubtes Verhältnis zwischen Einzel- und Sammelfahrtzeit (z. B. 1,5 = bis zu 50 % länger als eine Einzelfahrt)',
          },
          sharedRideDifferenceLimit: {
            label: 'Max. zusätzliche Sammelzeit',
            description:
              'Maximale zusätzliche Minuten, die zur Einzelfahrtzeit bei einer Sammelfahrt hinzugefügt werden dürfen',
          },
          maxSharedDistanceRatio: {
            label: 'Max. Sammelstrecken-Verhältnis',
            description:
              'Definiert, wie viel länger eine Sammelfahrt im Vergleich zur Einzelstrecke sein darf. Beispiel: Bei 1 km Einzelstrecke und einem Verhältnis von 1,2 darf die Sammelstrecke 1,2 km nicht überschreiten.',
          },
          maxTripStops: {
            label: 'Max. Stopps',
            description: 'Maximale Anzahl von Stopps pro Fahrt',
          },
          maxPickupStops: {
            label: 'Max. Abholstopps',
            description: 'Maximale Anzahl von Abholstopps pro Fahrt',
          },
          maxDropoffStops: {
            label: 'Max. Zielstopps',
            description: 'Maximale Anzahl von Zielstopps pro Fahrt',
          },
          maxTripDuration: {
            label: 'Max. Fahrtdauer',
            description: 'Maximale Dauer einer Fahrt in Minuten',
          },
          maxSinglePassengerTime: {
            label: 'Max. Einzelpassagier-Fahrzeit',
            description: '',
          },
          maxPassengers: {
            label: 'Max. Passagiere',
            description: 'Maximale Anzahl von Passagieren pro Fahrt',
          },
          maxPassengersAtOnce: {
            label: 'Max. gleichzeitige Passagiere',
            description:
              'Maximale Anzahl von Passagieren, die gleichzeitig befördert werden dürfen',
          },
          tripBoardingTime: {
            label: 'Einsteigezeit',
            description:
              'Zeit zum Einsteigen eines Passagiers an einem Stopp (wirkt sich auf die Gesamtdauer aus)',
          },
          subsequentPickTime: {
            label: 'Sekundäre Einsteigezeit',
            description:
              'Wenn deaktiviert, gilt die allgemeine Einsteigezeit. Bei Aktivierung werden Einsteigezeiten für nachfolgende Passagiere separat definiert.',
          },
          tripDropOffTime: {
            label: 'Ausstiegszeit',
            description:
              'Zeit zum Aussteigen eines Passagiers (wirkt sich auf die Gesamtdauer aus)',
          },
          subsequentDropOffTime: {
            label: 'Sekundäre Ausstiegszeit',
            description:
              'Wenn deaktiviert, gilt die allgemeine Ausstiegszeit. Bei Aktivierung werden Ausstiegszeiten für nachfolgende Passagiere separat definiert.',
          },
          maxBoardingDelay: {
            label: 'Max. Abholverspätung',
            description:
              'Maximale Minuten, die ein Fahrer zu spät zur Abholzeit erscheinen darf',
          },
          maxBoardingEarly: {
            label: 'Max. frühe Ankunft',
            description:
              'Maximale Minuten, die ein Fahrer zu früh zur Abholzeit erscheinen darf',
          },
          onlyPrivate: {
            label: 'Nur privat',
            description: 'Alle Fahrten als private Fahrten durchführen',
          },
        },
      },

      advanced: {
        title: 'Erweitert',
        parameters: {
          tripsJoinMode: {
            label: 'Zusammenführen versuchen',
            description:
              'Legt fest, ob neue Reservierungen bestehenden Fahrten hinzugefügt werden sollen: Nicht verbinden = 0, Versuchen = 1, Nur verbinden = 2',
            options: {
              dontJoin: 'Nicht verbinden',
              tryJoin: 'Versuchen',
              onlyJoin: 'Nur verbinden',
            },
          },
          maxJoinRadius: {
            label: 'Radius für Zusammenführung',
            description:
              'Maximaler Radius (km), in dem nach bestehenden Fahrten gesucht wird',
          },
          maxJoinTimeRange: {
            label: 'Zeitfenster für Zusammenführung',
            description:
              'Fahrten außerhalb dieses Zeitfensters werden nicht berücksichtigt',
          },
          maxReservationsAtOnce: {
            label: 'Max. Reservierungen gleichzeitig',
            description:
              'Maximale Anzahl von Reservierungen gleichzeitig im Fahrzeug',
          },
          minReservationDistance: {
            label: 'Min. Reservierungsdistanz',
            description:
              'Mindestdistanz (in Metern) zwischen Abholung und Ziel, damit eine Reservierung berücksichtigt wird',
          },
          maxEmptyTripTime: {
            label: 'Max. Leerlaufzeit',
            description:
              'Maximale Minuten, die eine Fahrt ohne Passagiere dauern darf',
          },
          maxDropOffEarly: {
            label: 'Max. frühes Absetzen',
            description:
              'Maximale Minuten, die ein Fahrer zu früh am Ziel ankommen darf',
          },
          maxDropOffDelay: {
            label: 'Max. verspätetes Absetzen',
            description:
              'Maximale Minuten, die ein Fahrer zu spät am Ziel ankommen darf',
          },
          pickPhaseRadius: {
            label: 'Abholradius',
            description:
              'Maximal erlaubte Distanz zwischen erster und weiterer Abholung',
          },
          pickPhaseMinutes: {
            label: 'Abhol-Zeitfenster',
            description:
              'Maximal erlaubte Zeit zwischen erster und weiterer Abholung',
          },
          groupWaitAndReturn: {
            label: 'Warten & Rückfahrt gruppieren',
            description:
              '• Aus: Keine Gruppierung\n\n• Einzelpaar: Hin- und Rückfahrt als eine Fahrt\n\n• Mehrere Paare: Mehrere Hin- und Rückfahrten zusammenfassen',
            options: {
              off: 'Aus',
              individualPair: 'Einzelpaar',
              multiplePairs: 'Mehrere Paare',
            },
          },
          pickupAllBeforeDropping: {
            label: 'Alle zuerst abholen',
            description:
              'Alle Passagiere werden zuerst abgeholt, bevor jemand abgesetzt wird',
          },
          waitForBoardingTime: {
            label: 'Auf Abholzeit warten',
            description:
              'Der Fahrer wartet am Stopp bis zur exakten Abholzeit',
          },
          sortStopsByPickupTime: {
            label: 'Nach Abholzeit sortieren',
            description:
              'Stopps werden nach Abholzeit statt geografisch sortiert',
          },
          balanceDepartureTime: {
            label: 'Abfahrtszeit ausgleichen',
            description:
              'Gleicht Wartezeiten der Passagiere aus',
          },
          angleDuration: {
            label: 'Winkel-Dauer',
            description:
              'Vermeidet Routenabschnitte mit zu langer Dauer und großem Winkel',
          },
          angleMax: {
            label: 'Max. Winkel',
            description:
              'Vermeidet Routenabschnitte mit zu großem Winkel',
          },
          allowActiveTripsRouteChanges: {
            label: 'Buchungen zu laufenden Fahrten hinzufügen',
            description:
              'Erlaubt „Zusammenführen“-Buchungen für laufende Fahrten',
          },
          vrpRunningTime: {
            label: 'VRP-Laufzeit',
            description:
              'Zeitlimit für die Optimierung – längere Laufzeiten ermöglichen bessere Ergebnisse',
          },
          editOnMap: {
            label: 'Auf Karte bearbeiten',
            description:
              'Erlaubt das manuelle Neuanordnen von Stopps per Drag & Drop',
          },
          consistentPassengerRouting: {
            label: 'Konsistente Fahrgast-Routenfuehrung',
            description:
              'Stellt sicher, dass dieselbe Fahrgastgruppe immer dieselbe Route zur und von der spezifischen Adresse nutzt, wodurch die Effizienz verbessert und Verwirrung reduziert wird.',
          },
          sameDriverForGroup: {
            label: 'Gleicher Fahrer fuer die Gruppe',
            description:
              'Weist denselben Fahrer fuer die Befoerderung der Fahrgastgruppe sowohl fuer Abholung als auch Absetzung zu und sorgt so fuer Vertrautheit und Konsistenz.',
          },
          routingMode: {
            label: 'Routenmodus',
            description: '',
            options: {
              default: 'Standard',
              hClustering: 'H-Clustering',
              vrp: 'VRP',
            },
          },
          defaultWillCallTime: {
            label: 'Standard-Will-Call-Versatz',
            description:
              'Fügt standardmäßig X Minuten zum Will-Call-Versatz hinzu',
          },
          enableWillCallTime: {
            label: 'Will-Call-Zeit aktivieren',
          },
        },
      },

      sameAreaLocation: {
        title: 'Same Zone / Location',
        parameters: {
          mergeReservationsByBoardingArea: {
            label: 'Same Pickup Zone',
            description: 'Bookings will be grouped together only if the pick-up location is in the same polygon.',
          },
          mergeReservationsByBoardingLocation: {
            label: 'Same Pickup Location',
            description: 'Bookings will be grouped together only if the pick-up location is the same.',
          },
          mergeReservationsByDropArea: {
            label: 'Same Drop-off Zone',
            description: 'Bookings will be grouped together only if the drop-off location is in the same polygon.',
          },
          mergeReservationsByDropLocation: {
            label: 'Same Drop-off Location',
            description: 'Bookings will be grouped together only if the drop-off location is the same.',
          },
          onlyGroupExactLocations: {
            label: 'Same Pickup Or Drop-off Location',
            description: 'Bookings will be grouped together only if the pickup or drop-off locations are the same.',
          },
          snapToLocation: {
            label: 'Snap To Location',
            description:
              'Automatically snap booking origin or destination to the closest known location from our internal locations management module, if it is within the snapToLocation radius. Value is in meters/foot based on your system type setting format.',
          },
          sameFlightNumber: {
            label: 'Gleiche Flugnummer',
            description:'Buchungen werden nur dann zusammengefasst, wenn die Flugnummer identisch ist.'          },
        },
      },

      evs: {
        title: 'EV’s',
        parameters: {
          minimalBatteryThreshold: {
            label: 'Minimum Battery Threshold',
            description:
              'This is the critical battery percentage that you do not want the system to go below during your journey. For example, if set to 30%, the system will aim to keep your battery above this level.',
          },
        },
      },

      reservationClusters: {
        title: 'Reservation Clusters',
        parameters: {
          isClusteringEnabled: {
            label: 'Clustering',
            description: 'Defines whether or not reservations clustering algorithms are enabled or not.',
          },
          clusterSnapTo: {
            label: 'Mode',
            description: 'Defines whether or not a cluster center address should be changed with a known road or a bus station',
            options: {
              address: 'Address',
              busStop: 'Bus Stop',
            },
          },
          clusterReservationsRadius: {
            label: 'Diameter',
            description: 'In what diameter to start combine reservation together into one pickup/drop spot',
          },
          clusterSnapMaxDistance: {
            label: 'Maximum Distance',
            description:
              'Maximum distance (in KM/Miles according to the defined system) in which cluster center address could be modified for a better location',
          },
          distanceType: {
            label: 'Distance Type',
            description: 'Defines whether Distance to cluster will be by Air Distance or Walking Distance',
            options: {
              airDistance: 'Air Distance',
              walkingDistance: 'Walking Distance',
            },
          },
          snapToShapeRatio: {
            label: 'Priority Stops/Clusters by Air Distance',
            description:
              'The system will attempt to create additional stops along the route if the passenger\'s air distance is shorter than the selected ratio',
          },
          snapToShapeUnite: {
            label: 'Minimum Distance Between Generated Stops',
            description: 'Minimum distance between created stops.',
          },
          maxPassengersInCluster: {
            label: 'Maximale Anzahl von Fahrgaesten im Cluster',
            description: 'Maximale Anzahl von Fahrgaesten, die in einem Cluster erlaubt ist. Diese Einstellung bleibt bearbeitbar, auch wenn das Clustering deaktiviert ist.',
          },
          keepVrpClusters: {
            label: 'VRP-Cluster beibehalten',
            description: 'Wenn aktiviert, bleibt die VRP-Ausgabe geclustert. Wenn deaktiviert, werden VRP-Cluster fuer ein erneutes Routing in einzelne Reservierungen aufgeteilt.',
          },
        },
      },

      smoothRoute: {
        title: 'Smooth Route',
        parameters: {
          smoothRouteEnabled: {
            label: 'Smooth Route',
            description:
              'Defines whether or not a cluster center address should be changed with a known road or a bus station or by Smooth Route.',
          },
          smoothRouteRadius: {
            label: 'Smooth Route Radius',
            description:
              'Defines the maximum walking distance (in meters) that a passenger may be required to walk when “Smooth Route” is enabled. This setting only takes effect if “Smooth Route” is turned on.',
          },
        },
      },

      traffic: {
        title: 'Traffic',
        parameters: {
          trafficRouteEnabled: {
            label: 'Traffic',
            modalHeader: 'Warning: Sensitive Traffic Settings',
            modalBody:
              'You are about to edit advanced traffic configuration settings. These values directly affect how routes are calculated and may significantly alter system behavior. Please proceed only if you fully understand the implications. To confirm, type "traffic" below and click "Confirm".',
          },
          minTraffic: {
            label: 'Minimum',
            description: 'Minimal ratio between the traffic duration and map server duration',
          },
          baseTraffic: {
            label: 'Base',
            description: 'Multiply all calculated durations by a base ratio (X). Higher values increase estimated travel times.',
          },
          hourTraffic: {
            label: 'Hour',
            description:
              'An array of 24 hourly ratios (00:00–23:59). Each value adjusts trip duration multipliers based on the hour of the day.',
          },
        },
      },
    },
  },

  assignment: {
    title: 'Driver Assignment',
    pageTitle: 'Driver Assignment Settings',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          distanceFromTripScore: {
            label: 'Distance',
            description:
              'Give higher priority if you wish to increase the chances that the driver that is the closest to the trip will be assigned.',
          },
          timeFromTripScore: {
            label: 'Time',
            description:
              'Give higher priority if you wish to increase the chances that the driver that can get fastest to the starting point will be assigned.',
          },
          gapTimeScore: {
            label: 'Idle',
            description:
              'A higher priority will increase the chances that a driver whos waiting for his next job the most time will be assigned.',
          },
          assignedTripsScore: {
            label: 'Number of Trips',
            description:
              'The higher the priority the higher the chances that someone that already assinged will be assigned again. Give lower priority to balance the trips between active drivers and high prioirty to have the least amount of drivers necessary.',
          },
          accumulatedSalaryScore: {
            label: 'Earnings',
            description:
              'Give a high prioirty if you wish to balance the amount of drivers based on their salaries (Using the most drivers). Give a low prioirty if you wish to use the least amount of drivers.',
          },
          algorithmCode: {
            label: 'Algorithmuscode',
            options: {
              dateOrdering: 'Datumsreihenfolge',
              dynamicOrdering: 'Dynamische Reihenfolge',
            },
          },
          driverAssignmentStrategy: {
            label: 'Fahrerzuweisungsstrategie',
            options: {
              minimumFleetUsage: 'Minimale Flottennutzung',
              balanceAvailableDrivers: 'Ausgleich – Verfügbare Fahrer',
              balanceMinimumRequiredDrivers: 'Ausgleich – Mindestens erforderliche Fahrer',
            },
          },
        },
      },

      limits: {
        title: 'Limits',
        parameters: {
          maxTripsPerDriver: {
            label: 'Max Trips',
            description: 'The maximum amount of trips a driver could be assigned to on a given request.',
          },
          maxAccumulatedSalary: {
            label: 'Max Price',
            description:
              'The maximum sum of salary a driver could be making in the process of assignment (and then other drivers will be prioritized)',
          },
        },
      },

      advanced: {
        title: 'Advanced Settings',
        parameters: {
          distanceFromHomeScore: {
            label: 'Distance From Home',
            description: 'If you wish to keep drivers close to home (their starting location) you should give a high priority',
          },
          nextTripDistanceScore: {
            label: 'Distance From Next Trip',
            description:
              'When we \'fill holes\' in the middle of a driver\'s plan for the day, we wish to get him closer to his next future trip\'s departure.So, for each meter away from his upcoming trip, his score for the current considered trip will be lowered.',
          },
          idleBonusMinutes: {
            label: 'Idle Bonus Minutes',
            description: 'Period that the driver needs to stay idle to receive the ${}',
          },
          idleBonusScore: {
            label: 'Idle Bonus Score',
            description: 'The amount of points added to driver score after being idle for ${} minutes.',
          },
          scorePerEmptySeats: {
            label: 'Per Empty Seat',
            description:
              'Use this setting to specify your preference for minimizing empty seats in the vehicle (The more negative the value, the stronger the avoidance).',
          },
          assignPriorityBonusMax: {
            label: 'Prioritätsbonus für benutzerdefinierte Regeln – Maximum',
            description: 'Maximum score awarded to the highest-priority attribute when assigning trips',
          },
          assignPriorityBonusMin: {
            label: 'Prioritätsbonus für benutzerdefinierte Regeln – Minimum',
            description: 'Minimum score awarded to the lowest-priority attribute when assigning trips',
          },
          areaMatchScore: {
            label: 'Zone Match',
            description:
              'The higher the priority, the more likely a driver that belongs to the trip\'s zone will be assigned. If you wish to fully restrict assignment for drivers from the same zone as the trip, the give it the highest priorty.',
          },
          scorePerVehicleCost: {
            label: 'Cost Per Vehicle',
            description: '',
          },
          perAssignmentScore: {
            label: 'Punktzahl pro Zuweisung',
            description: 'Fügt eine Punktzahl für jede einem Fahrer zugewiesene Fahrt hinzu. Höhere Werte verhindern die Zuweisung mehrerer Fahrten an denselben Fahrer.',
          },
          perLoadedDistance: {
            label: 'Punktzahl pro beladene Distanz',
            description: 'Fügt eine Punktzahl basierend auf der Streckenlänge von Fahrten mit Fahrgästen (beladene Kilometer) hinzu. Höhere Werte priorisieren kürzere Fahrten und reduzieren die gesamte beladene Distanz.',
          },
          isAssignBlocked: {
            label: 'Block Auto Assign',
            description: 'When Auto-Assign is turned off, selected profiles will not be automatically assigned',
          },
          assignBlockedProfiles: {
            label: 'Blocked Profiles',
            description: 'Choose which profiles should not be automatically assigned by the platform',
          },
          assignBlockedAttributes: {
            label: 'Blocked Attributes',
            description: 'Choose which attributes should not be automatically assigned by the platform',
          },
          allowFlexibleTimes: {
            label: 'Allow Flexible Times',
            description:
              'Optimize driver assignments and reduce vehicle usage by modifying trip departure times while adhering to Max Boarding Delay and Max Boarding Early rules.',
          },
          unassignOnVehicleChange: {
            label: 'Disable unassign driver on vehicle change',
            description:
              'Changing a driver to another vehicle with matching “Driver/Vehicle-Booking Attribute Matching” attributes will not automatically unassign the Driver’s trip.',
          },
          consistentSupplier: {
            label: 'Consistent Supplier',
            description: 'The system will assign drivers from the same supplier to a passenger’s bookings within a single day, disregarding driver limitations.'
          },
          assignBySupplier: {
            label: 'Assign By Supplier',
            description: '',
          },
          supplierPriorityMode: {
            label: 'Supplier Order',
            description: '',
            options: {
              byRank: 'By Rank',
              byTier: 'By Tier'
            }
          },
          shiftAllocationWeight: {
            label: 'Driver Availability',
            description: 'The amount of points added to driver score per shift duration',
          }
        },
      },

      driverShifts: {
        title: 'Driver Shifts',
        parameters: {
          ignoreDriverShifts: {
            label: 'Ignore Driver Shifts',
            description: 'Driver assignment process take driver shifts into account',
          },
          startShiftWithTrip: {
            label: 'Start Shift With Trip',
            description:
              'Assigns drivers to trips at the start of their shift without factoring in travel time to the first pickup. Drivers are responsible for reaching the initial pickup location promptly at the shift\'s start time',
          },
          maxShiftHours: {
            label: 'Shift Max Time',
            description:
              'The maximum length (in hours) of a driver shift. The engine wont let a driver be considered active more than this amount of hours.',
          },
          shiftGap: {
            label: 'Shift Gap',
            description: 'Set the mandatory break duration between consecutive shifts',
          },
          driverRestAfterTrip: {
            label: 'Enforce Break',
            description: 'Drivers are prompted to take a rest after each trip.',
          },
        },
      },

      mobileApp: {
        title: 'Driver Shifts App',
        parameters: {
          allowShiftCreation: {
            label: 'Allow Shift Creation',
            description: 'Enable drivers to create new shifts in their schedule.',
          },
          allowBreaksInShifts: {
            label: 'Allow Breaks in Shifts',
            description: 'Permit drivers to include break periods within their shifts.',
          },
          enableShiftDeletion: {
            label: 'Allow Shift Deletion',
            description: 'Allow drivers to delete their scheduled shifts if needed.',
          },
          minimumShiftCancellationNotice: {
            label: 'Minimum Shift Cancellation Notice',
            description: 'Set the minimum required time before a shift starts for a driver to cancel it.',
          },
          maxShiftAvailability: {
            label: 'Max Shift Availability',
            description: 'Define the longest availability time slot a driver can set for themselves.',
          },
          enableRecurringShifts: {
            label: 'Enable Recurring Shifts',
            description: 'Allow drivers to create recurring shifts on a custom date range.',
          },
        },
      },

      virtualReal: {
        title: 'Virtual vs Real',
        parameters: {
          assignmentType: {
            label: 'Assignment Type',
            description: 'Default assignment mode (Actual Drivers vs Virtual Drivers)',
            options: {
              virtual: 'Virtual',
              real: 'Real',
            },
          },
          addVirtualDrivers: {
            label: 'Fill with Virtual Drivers',
            description:
              'Automatically assigns virtual drivers to trips when there\'s a shortage of available drivers. Helps estimate fleet requirements by simulating additional drivers to cover the workload',
          },
          defaultCarLocation: {
            label: 'Default Car Location',
            description: 'The default start location to be considered for a vehicle/driver if don\'t has its own.',
          },
          defaultCarSeats: {
            label: 'Default Seats',
            description: 'Default number of seats to be considered for a vehicle if not defined.',
          },
        },
      },
    },
  },

  distribution: {
    title: 'Distribution',
    pageTitle: '',
    groups: {
      base: {
        title: 'Fleets KPIs weight',
        parameters: {
          onTimePerformance: {
            label: 'On-Time Performance',
            description: '',
          },
          noShowRate: {
            label: 'No Show Rate',
            description: '',
          },
          cancellationRate: {
            label: 'Cancellation Rate',
            description: '',
          },
          acceptanceRate: {
            label: 'Acceptance Rate',
            description: '',
          },
          responseTime: {
            label: 'Response Time',
            description: '',
          },
          costEfficiency: {
            label: 'Cost Efficiency',
            description: '',
          },
        }
      }
    }
  },
  advancedSettingsPopups: {
    maxDurationByDistance: {
      title: 'Configure Max Duration by Distance',
      form: {
        fields: {
          startKm: 'From ({{unit}})',
          endKm: 'To ({{unit}})',
          durationMinutes: 'Max Duration (min)',
        },
        btnAddRange: 'Add Range',
        btnSubmit: 'Save',
        btnClose: 'Close',
      },
    }
  }
};

export default settings;
